import { useState } from "react";
import { API } from "../lib/api";
import { VideoThumb } from "./VideoThumb";

export const InlinePlayer = ({ videoId, className = "", testid }) => {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <video
        data-testid={testid ? `${testid}-video` : undefined}
        src={`${API}/videos/${videoId}/file`}
        controls
        autoPlay
        playsInline
        className={`w-full h-full object-contain bg-black ${className}`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      data-testid={testid}
      className={`block w-full h-full cursor-pointer ${className}`}
      aria-label="Play swing video">
      <VideoThumb videoId={videoId} className="w-full h-full" testid={testid ? `${testid}-thumb` : undefined} />
    </button>
  );
};
